import React from "react";
import { Modal } from "react-bootstrap";
import LoginForm from "./LoginForm";

const MobileLoginModal = ({
  show,
  onHide,
  onSubmit,
  onForgotPassword,
  disabled,
  isForgotPasswordPage,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Login</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <LoginForm
          onSubmit={onSubmit}
          onForgotPassword={onForgotPassword}
          disabled={disabled}
          isForgotPasswordPage={isForgotPasswordPage}
          buttonClassName="mobile-modal-button"
          forgotPasswordClassName="mobile-forgot-password-btn"
        />
      </Modal.Body>
    </Modal>
  );
};

export default MobileLoginModal;